export enum FormEntryType {
  TEXTAREA = 'textarea', NUMBER = 'number', RADIO = 'radio', CHECKBOX = 'checkbox'
}

export interface FormValuePair {
  value: string,
  id: string
}

export interface FormEntry {
  type: FormEntryType,
  required: boolean,
  id: string,
  label: string,
  values: FormValuePair[]
  photo?: { image?: any, required: boolean };
  defaultValue?: any;
}



// WEBPACK FOOTER //
// ./src/modules/engine/model/engine-form.model.ts